export default "__VITE_ASSET__b99deadb__"